import { ArrowRight, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative isolate overflow-hidden pt-32 pb-20 sm:pt-40 sm:pb-28"
    >
      {/* layered background */}
      <div className="absolute inset-0 -z-10 rsm-grid-bg opacity-90" />
      <div
        className="absolute inset-x-0 top-0 -z-10 h-[640px] opacity-[0.18]"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1644325349124-d1756b79dd42?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGRhdGElMjBuZXR3b3JrJTIwYmx1ZXxlbnwwfHx8fDE3Nzg4NTc1MjF8MA&ixlib=rb-4.1.0&q=85)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          maskImage:
            "linear-gradient(to bottom, black 30%, transparent 95%)",
          WebkitMaskImage:
            "linear-gradient(to bottom, black 30%, transparent 95%)",
        }}
      />
      <div
        className="absolute -top-32 right-[-10%] -z-10 h-[520px] w-[520px] rounded-full blur-3xl opacity-30"
        style={{ background: "radial-gradient(closest-side, #208BFF, transparent 70%)" }}
      />

      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-end">
          <div className="lg:col-span-8 rsm-rise">
            <div
              data-testid="hero-eyebrow"
              className="inline-flex items-center gap-2 rounded-full border border-[#1B1D1D]/10 bg-white/70 backdrop-blur px-4 py-1.5 text-xs font-semibold tracking-[0.18em] uppercase text-[#1B1D1D]"
            >
              <Sparkles size={12} className="text-[#208BFF]" />
              RSM Politics
            </div>

            <h1
              data-testid="hero-headline"
              className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter leading-[0.94] text-[#1B1D1D]"
            >
              Transforme sua base em um{" "}
              <span className="relative inline-block">
                <span className="relative z-10 text-[#208BFF]">
                  exército organizado
                </span>
                <span className="absolute inset-x-0 bottom-1 h-3 -z-0 bg-[#208BFF]/15 rounded" />
              </span>{" "}
              para realizar ações de marketing.
            </h1>

            <p
              data-testid="hero-subhead"
              className="mt-8 max-w-2xl text-lg sm:text-xl leading-relaxed text-[#51565F]"
            >
              Uma plataforma nascida em Brasília que organiza, mede e mobiliza
              apoiadores em tempo real. Mais que um CRM eleitoral — uma máquina
              de base que reage à narrativa enquanto ela acontece.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <a
                href="#contato"
                data-testid="hero-primary-cta"
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#208BFF] px-7 py-4 text-base font-semibold text-white shadow-sm transition-all duration-300 ease-out hover:bg-[#1B73D6] hover:-translate-y-0.5 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#208BFF] focus:ring-offset-2 focus:ring-offset-[#F5FAFB]"
              >
                Quero minha base na RSM
                <ArrowRight
                  size={18}
                  className="transition-transform group-hover:translate-x-1"
                />
              </a>
              <Link
                to="/politics/agencies"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-[#1B1D1D]/15 bg-white/70 backdrop-blur px-7 py-4 text-base font-medium text-[#1B1D1D] transition-all duration-300 ease-out hover:border-[#7E20FF] hover:text-[#7E20FF]"
              >
                Sou agência / consultor
              </Link>
            </div>

            <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-[#51565F]">
              <span className="inline-flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#3ED383]" />
                Operação em tempo real
              </span>
              <span className="inline-flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#208BFF]" />
                Suporte jurídico-eleitoral
              </span>
              <span className="inline-flex items-center gap-2">
                <span className="h-1.5 w-1.5 rounded-full bg-[#7E20FF]" />
                IA aplicada a campanhas
              </span>
            </div>
          </div>

          {/* Side panel — visual signal of "app" / dashboard */}
          <div className="lg:col-span-4 lg:pl-4 rsm-rise rsm-rise-delay-2">
            <div
              data-testid="hero-side-card"
              className="rounded-2xl border border-[#1B1D1D]/8 bg-white p-6 shadow-sm"
            >
              <div className="flex items-center justify-between">
                <span className="text-xs font-semibold tracking-[0.18em] uppercase text-[#7D8188]">
                  Painel · Hoje
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-[#3ED383]/12 px-2 py-0.5 text-[10px] font-semibold text-[#1d8b51]">
                  <span className="h-1.5 w-1.5 rounded-full bg-[#3ED383] animate-pulse" />
                  AO VIVO
                </span>
              </div>

              <div className="mt-5 space-y-4">
                <Stat label="Apoiadores ativos" value="12.847" delta="+4,2%" />
                <Stat label="Missões cumpridas" value="2.319" delta="+18%" />
                <Stat
                  label="Engajamento médio"
                  value="74%"
                  delta="↑ +6 pts"
                  positive
                />
              </div>

              <div className="mt-6 border-t border-[#1B1D1D]/8 pt-4">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#7D8188]">
                  Termômetro regional
                </span>
                <div className="mt-3 flex items-end gap-1.5 h-16">
                  {[40, 62, 38, 80, 55, 68, 72, 90, 58, 76, 64, 88].map(
                    (v, i) => (
                      <div
                        key={`bar-${v}`}
                        className="flex-1 rounded-sm bg-gradient-to-t from-[#208BFF]/20 to-[#208BFF]"
                        style={{ height: `${v}%` }}
                      />
                    ),
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value, delta, positive = true }) {
  return (
    <div className="flex items-end justify-between">
      <div>
        <div className="text-xs uppercase tracking-wider text-[#7D8188] font-semibold">
          {label}
        </div>
        <div className="font-display text-2xl font-bold tracking-tight text-[#1B1D1D] mt-1">
          {value}
        </div>
      </div>
      <span
        className={`text-xs font-semibold ${
          positive ? "text-[#1d8b51]" : "text-[#D94A0A]"
        }`}
      >
        {delta}
      </span>
    </div>
  );
}
